import { IV3D } from '@/Interfaces/v3d';

declare let v3d: IV3D;

const geometry = new v3d.SphereGeometry(0.01, 6, 6);
const material = new v3d.MeshBasicMaterial({ color: 0xffff00 });
export const getStartPointMesh = () => new v3d.Mesh(geometry, material);
// startPointMesh.visible = false;